import { Theme } from "@mui/material/styles";

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
  dialogPaper: {
    margin: theme.spacing.spacing5,
    borderRadius: theme.borders.borderRadius.xl,
    padding: `${theme.spacing.spacing22} ${theme.spacing.spacing11}`,
    width: "100%",
    maxWidth: "360px",
    backgroundColor: theme.palette.background.default,
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.size.lg,
    textAlign: "center",
    color: theme.palette.text.primary,
    padding: 0,
    marginBottom: theme.spacing.spacing8,
  },
  body: {
    fontSize: theme.typography.size.md,
    textAlign: "center",
    color: theme.palette.text.primary,
    lineHeight: theme.typography.lineHeight.md,
    marginBottom: theme.spacing.spacing10,
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing.spacing10,
    width: theme.width.full,
    padding: 0,
  },
  primaryButton: {
    width: theme.width.full,
    height: theme.spacing.spacing28,
    fontSize: theme.typography.size.md,
  },
  secondaryButton: {
    minWidth: "unset",
    height: "auto",
    padding: theme.spacing.spacing2,
    fontSize: theme.typography.size.md,
  },
});
